import { supabase } from '@/services/supabase';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/sitemap/xml')({
  component: SitemapXML,
  loader: async () => {
    // Fetch all published blog posts
    const { data: posts, error } = await supabase
      .from('blog_posts')
      .select('slug, updated_at')
      .eq('status', 'published');
    
    if (error) throw error;
    
    return posts;
  },
});

function SitemapXML() {
  const posts = Route.useLoaderData();
  
  // Set the content type to XML
  if (typeof document !== 'undefined') {
    const contentType = document.createElement('meta');
    contentType.httpEquiv = 'Content-Type';
    contentType.content = 'text/xml; charset=utf-8';
    document.head.appendChild(contentType);
  }
  
  // Build the sitemap XML
  const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <!-- Main Pages -->
  <url>
    <loc>https://www.swimhomes.ca/</loc>
    <changefreq>weekly</changefreq>
    <priority>1.0</priority>
  </url>
  <url>
    <loc>https://www.swimhomes.ca/about</loc>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://www.swimhomes.ca/blog</loc>
    <changefreq>weekly</changefreq>
    <priority>0.9</priority>
  </url>
  <url>
    <loc>https://www.swimhomes.ca/sellers-guide</loc>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://www.swimhomes.ca/properties</loc>
    <changefreq>daily</changefreq>
    <priority>0.9</priority>
  </url>
  <url>
    <loc>https://www.swimhomes.ca/terms-of-service</loc>
    <changefreq>yearly</changefreq>
    <priority>0.5</priority>
  </url>
  <url>
    <loc>https://www.swimhomes.ca/privacy-policy</loc>
    <changefreq>yearly</changefreq>
    <priority>0.5</priority>
  </url>
  <url>
    <loc>https://www.swimhomes.ca/ai-disclaimer</loc>
    <changefreq>yearly</changefreq>
    <priority>0.5</priority>
  </url>
  
  <!-- Blog Posts -->
  ${posts.map(post => {
    const lastmod = post.updated_at ? new Date(post.updated_at).toISOString().split('T')[0] : '';
    return `<url>
    <loc>https://www.swimhomes.ca/blog/${post.slug}</loc>
    <changefreq>monthly</changefreq>
    ${lastmod ? `<lastmod>${lastmod}</lastmod>` : ''}
    <priority>0.7</priority>
  </url>`;
  }).join('\n  ')}
</urlset>`;

  return (
    <pre style={{ display: 'none' }} dangerouslySetInnerHTML={{ __html: sitemap }} />
  );
}

export default SitemapXML; 